import React from 'react';
import ConfigPopover from '../ConfigPopover';

const ChunkLoadingPopover: React.FC<any> = props => {
  return <ConfigPopover isLoading onClose={props.close} />;
};
ChunkLoadingPopover.displayName = 'ChunkLoadingPopover';

export default ChunkLoadingPopover;
